export enum SuppliersRoles {
  VIEWER = 'roles.suppliersViewer',
  PERSISTER = 'roles.suppliersPersister',
  ARCHIVER = 'roles.suppliersArchiver',
  COLLECTION_MANAGER = 'roles.suppliersCollectionManager',
}
